import { createStyles, Grid, makeStyles, Typography } from "@material-ui/core"
import React from "react"

import { GetChartAccountDto } from "services/api/openapi"

const useStyles = makeStyles(() =>
  createStyles({
    color: {
      display: "inline-block",
      width: 14,
      height: 14,
      flexShrink: 0,
      borderRadius: 3,
      marginRight: 8,
      marginTop: 2,
    },
    text: {
      flexGrow: 1,
    },
  }),
)

interface Props {
  account: Pick<GetChartAccountDto, "name" | /* | "color" */ "type" | "code">
}

const ChartAccountOptionInAutocomplete = ({ account }: Props) => {
  const classes = useStyles()

  return (
    <Grid container alignItems="center">
      <Grid item xs>
        <Typography variant="body1">
          {/* <span className={classes.color} style={{ backgroundColor: ColorHex[account.color] }} /> */}
          <span className={classes.text}>{account.name}</span>
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          {account.code && `${account.code} - `}
          {account.type}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ChartAccountOptionInAutocomplete
